// Entity-type badge colors. Hues come from the categorical `--cat-*` token
// palette (defined in index.css, OKLCH-balanced) so the whole set can be
// retuned in one place. Each type: a faint tinted bg + the same hue as text.
export const LABEL_COLORS: Record<string, string> = {
  Person: 'bg-cat-1/10 text-cat-1',
  Phone: 'bg-cat-2/10 text-cat-2',
  Vehicle: 'bg-cat-3/10 text-cat-3',
  MobileDevice: 'bg-cat-4/10 text-cat-4',
  BTSStation: 'bg-cat-5/10 text-cat-5',
  PhoneCall: 'bg-cat-6/10 text-cat-6',
  SocialAccount: 'bg-cat-7/10 text-cat-7',
  SocialPost: 'bg-cat-8/10 text-cat-8',
  FuelTransaction: 'bg-cat-9/10 text-cat-9',
  Location: 'bg-cat-10/10 text-cat-10',
  // Financial / identifier types (structured ingest projections)
  BankAccount: 'bg-cat-8/10 text-cat-8',
  Bank: 'bg-cat-6/10 text-cat-6',
  Company: 'bg-cat-7/10 text-cat-7',
  Organisation: 'bg-cat-7/10 text-cat-7',
  Organization: 'bg-cat-7/10 text-cat-7',
  CryptoAddress: 'bg-cat-9/10 text-cat-9',
  CryptoAccount: 'bg-cat-9/10 text-cat-9',
  ExchangeAccount: 'bg-cat-9/10 text-cat-9',
  PhoneNumber: 'bg-cat-2/10 text-cat-2',
  EmailAddress: 'bg-cat-2/10 text-cat-2',
  IPAddress: 'bg-cat-5/10 text-cat-5',
  Address: 'bg-cat-10/10 text-cat-10',
}

export function entityLabelColor(label: string): string {
  return LABEL_COLORS[label] || 'bg-muted text-muted-foreground'
}
